import axios from 'axios'
import Cookies from "js-cookie";
// import { getCookie } from "./cookies";
import Storage from "utils/Storage";



const http = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  headers: {
    Authorization: {
      toString () {
        const authToken =  Storage.get("auth_token") || Cookies.get("authToken")
        return `Bearer ${authToken}`
      }
    }
  }
})

// http.interceptors.request.use (
//   function (config) {
//     const token = Storage.get('auth_token');
//     if (token) config.headers.Authorization = `Bearer ${token}`;
//     return config;
//   },
//   function (error) {
//     return Promise.reject (error);
//   }
// );

export default http;